import { serverURL } from "./constants";

const findCompanyByEmail = async email => {
  const apiOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email })
  };

  try {
    const response = await fetch(`${serverURL}/company/user/find`, apiOptions);

    const status = response.status;

    const data = await response.json();

    if (status !== 200) {
      throw data;
    }

    return data;
  } catch (e) {
    throw e;
  }
};

const createUser = (data) => {
  return fetch(`${serverURL}/company/user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });
};

const api = {
  findCompanyByEmail,
  createUser
};

export default api;



// WEBPACK FOOTER //
// ./src/assets/config/api.js